import type { EmployeeResponse } from "./EmployeeResponse";
import type { EmployeeRequest } from "./EmployeeRequest";
import type { SkillDto } from "../common";

export class EmployeeListItem {
  employeeId: number;
  userId?: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  employeeStatusLookupId: number;
  employeeStatusName: string;
  skills: SkillDto[];
  isActive: boolean;
  createdDate: string;
  createdBy: string;
  modifiedDate: string;
  modifiedBy: string;

  constructor(response: EmployeeResponse) {
    this.employeeId = response.employeeId;
    this.userId = response.userId;
    this.firstName = response.firstName;
    this.lastName = response.lastName;
    this.email = response.email;
    this.phone = response.phone;
    this.employeeStatusLookupId = response.employeeStatusLookupId;
    this.employeeStatusName = response.employeeStatusName;
    this.skills = response.skills;
    this.isActive = response.isActive;
    this.createdDate = response.createdDate;
    this.createdBy = response.createdBy;
    this.modifiedDate = response.modifiedDate;
    this.modifiedBy = response.modifiedBy;
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  toRequest(): EmployeeRequest {
    return {
      userId: this.userId,
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email || undefined,
      phone: this.phone || undefined,
      employeeStatusLookupId: this.employeeStatusLookupId,
      skillLookupIds: this.skills.map(s => s.skillLookupId),
      isActive: this.isActive
    };
  }
}
